import { useCallback } from "react";
import { ErrorOption } from "react-hook-form";
import { useIssueFormatter } from "../../../application/hooks/useIssueFormatter";
import { ExtraCategory } from "../../../domain/ExtraCategory.enum";
import { GrpcIssues } from "../../../infrastructure/grpcIssues";
import { ExtraCategoryField, extraCategoryFieldErrors } from "./extraCategoryInputs.viewModel";

type SetFieldError = (name: ExtraCategoryField, error: ErrorOption) => void;

/**
 * Places the issues of a rejected extra save on the category fields. The returned
 * function tells whether any was placed; when none, the caller keeps today's error handling.
 */
export function useExtraCategoryIssues(
  setError: SetFieldError
): (error: unknown, category: ExtraCategory) => boolean {
  const formatter = useIssueFormatter();

  return useCallback(
    (error: unknown, category: ExtraCategory) => {
      const fieldErrors = extraCategoryFieldErrors(GrpcIssues.read(error), category, formatter);
      fieldErrors.forEach(({ field, message }) => setError(field, { type: "server", message }));
      return fieldErrors.length > 0;
    },
    [formatter, setError]
  );
}
